import React from 'react'
import {connect} from 'react-redux'
import BattleActions from '../battle-data/battle-actions.js'
import {getTargets} from '../get-targets'
import {submitAction} from '../lifecycle/submit-action.js'
import {getTargetIdsFromConjoinedString} from '../get-target-ids-from-conjoined-string.js'

class SubmissionMenu extends React.Component {

  constructor(props) {
    super();

    //This stuff is just for Console View. The menu-engine project will handle the Arena View optionIds and stuff.

    const model = props.model;

    //Determine if we are able to select ALL TEAM ITEMS or just my own. (Feature Flag)
    //const availableItems = props.ff_IsTeamItemsOn ? model.getTeamItems() : model.items;

    const actionOptions = model.getAvailableActions();
    const initialActionKey = actionOptions[0].actionId;
    const initialTargets = getTargets(initialActionKey, model.belongsToTeam, model.id);

    this.state = {
      hasBeenSubmitted: false,
      actionOptions: actionOptions,
      selectedActionIndex: 0,
      selectedActionId: initialActionKey,
      actionTargets: initialTargets,
      //selectedTargetId: this.getFirstAliveCombatant(initialTargets, props.combatants)
      selectedTargetId: initialTargets[0]
    }
  }


  getFirstAliveCombatant(targetIds, combatants) {

    const isMultipleTargets = targetIds.length && targetIds[0].match(",");
    if (isMultipleTargets) {
      return targetIds[0]; //return multiple targets if this is a combo
    }

    return targetIds.find(id => {
      const combModel = combatants[id];
      return combModel.isAlive()
    })
  }


  componentWillUpdate(newProps) {
    //If this person gets to go twice in a row,
    //Make sure button state is updated if we switch from "me" to "deadline:me"
    //Because this component does not actually unmount in that case. (Console only)
    if (this.props.combatantSelectingAction !== newProps.combatantSelectingAction) {
      this.setState({
        hasBeenSubmitted: false //reset
      })
    }
  }


  handleActionChange(changeEvent) {
    const newActionIndex = changeEvent.target.value; //set active value to new actionId
    const newActionId = this.state.actionOptions[newActionIndex].actionId;
    const newTargetOptions = getTargets(newActionId, this.props.model.belongsToTeam, this.props.model.id);

    this.setState({
      selectedActionIndex: newActionIndex,
      actionTargets: newTargetOptions,
      selectedTargetId: newTargetOptions[0]
    });
  }

  handleTargetChange(changeEvent) {
    const newTargetId = changeEvent.target.value;
    this.setState({
      selectedTargetId: newTargetId
    })
  }


  /** Submit the console UI */
  handleSubmit() {

    this.setState({
      hasBeenSubmitted: true
    });

    //Turn comma list into a group of an array of Target Combatant models.
    const selectedTargetCombatants = getTargetIdsFromConjoinedString(
      this.state.selectedTargetId,
      this.props.combatants
    );

    //Use the active index of the list to determine which model to use.
    //(We need the whole object, like what is in combatant `attacks` or `items` array.. need libraryId and stolenData, hasTimedHitBonus, etc)

    const hasTimedHitBonus = this.refs.timedHitCheckbox && this.refs.timedHitCheckbox.checked;
    const selectedActionData = {
      ...this.state.actionOptions[this.state.selectedActionIndex],
      hasTimedHitBonus: hasTimedHitBonus
    };
    const selectedActionId = selectedActionData.actionId;

    //TODO: Need to refactor this file to select the whole action object rather than just the ID. So we can merge the selected Object in.
    //TODO: Submission needs to include this data.


    submitAction(
      {
        id: selectedActionId,
        ...BattleActions[selectedActionId],
        actionMeta: selectedActionData,
      },
      this.props.model,
      selectedTargetCombatants
    )
  }

  isButtonDisabled() {
    if (!this.state.selectedTargetId) {
      return true
    }
    return false
  }

  renderWarning(actionModel, casterModel, targetModels) {

    if (targetModels.length > 1) {
      return null;
    }

    const validityModel = actionModel.getValidity(actionModel, casterModel, targetModels);

    if (!validityModel.isValid) {
      return (
        <div>WARNING! {validityModel.invalidReasons[0]}</div>
      )
    }

    return null
  }

  renderTimedHitCheckbox(actionModel) {
    // if (actionModel.hasTimedHitBonusAvailable) {
    //   return (
    //     <div>
    //       Timed Hit Bonus?
    //       <input type="checkbox" ref="timedHitCheckbox" />
    //     </div>
    //   )
    // }
    return null
  }





  render() {

    //Don't render UI if we've already submitted (after button click.. prevents duplicates)
    if (this.state.hasBeenSubmitted) {
      return (
        <div>SUBMITTED!</div>
      )
    }

    //Render ConsoleView form

    const selectedActionId = this.state.actionOptions[this.state.selectedActionIndex].actionId;
    const selectedActionModel = BattleActions[selectedActionId];
    const selectedTargetCombatant = this.props.combatants[this.state.selectedTargetId];

    return (
      <div className="SubmissionMenu">
        <p>SUBMIT ACTION:</p>
        <div>
          <label>Action</label>
          <select value={this.state.selectedActionIndex} onChange={this.handleActionChange.bind(this)}>
            {
              this.state.actionOptions.map((action, i) => {
                const model = BattleActions[action.actionId];
                if (!model) {
                  console.warn('no action found', action.actionId)
                }
                const stolenText = (action.isStolen) ? " - STOLEN!" : null;

                let displayName = model.name;
                if (model.isItem) {
                  displayName = `[ITEM] ${displayName}`
                }
                if (model.isSuper) {
                  displayName = `[SUPER] ${displayName}`
                }

                return (
                  <option value={i} key={i}>
                    {displayName}{stolenText}
                  </option>
                )
              })
            }
          </select>
        </div>
        {this.renderTimedHitCheckbox(selectedActionModel)}
        <div className="SubmissionMenu-description">
          {selectedActionModel.description}
        </div>
        <div>
          <label>Target</label>
          <select value={this.state.selectedTargetId} onChange={this.handleTargetChange.bind(this)}>
            {
              this.state.actionTargets.map((targetId, i) => {

                const isMultipleTargets = targetId.match(",");
                if (isMultipleTargets) {
                  //<option value={targetId} key={i}>[Multiple Targets]</option>
                  return (
                    <option value={targetId} key={i}>{targetId}</option>
                  )
                }

                //TODO: This kind of "valid target" logic will need to be used in the Menu library
                const targetModel = this.props.combatants[targetId] || {};
                let isDisabled = false;
                if (selectedActionModel.targetMustBeDead && targetModel.isAlive()) {
                  isDisabled = true
                }
                if (!selectedActionModel.targetMustBeDead && !targetModel.isAlive()) {
                  isDisabled = true
                }

                //<option value={targetId} key={i}>{targetId}</option>
                return (
                  <option value={targetId} key={i} disabled={isDisabled}>{targetModel.name}</option>
                )
              })
            }
          </select>
        </div>

        {
          this.renderWarning(selectedActionModel, this.props.model, [selectedTargetCombatant])
        }
        <button disabled={this.isButtonDisabled()} onClick={this.handleSubmit.bind(this)}>Submit</button>

      </div>
    );
  }
}


export default connect((state, props) => {
  return {
    combatants: state.battle.combatants,
    combatantSelectingAction: state.battle.combatantSelectingAction,

    //Feature Flag:
    ff_IsTeamItemsOn: state.battle.ff_IsTeamItemsOn,
  }
})(SubmissionMenu)


// WEBPACK FOOTER //
// ./src/battle/ConsoleView/SubmissionMenu.js